import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { useThemeStore } from '../../../stores/useThemeStore';
import logoLight from '../../../assets/MainLogo/MKraftLogoLight.png';
import logoDark from '../../../assets/MainLogo/MKraftLogoDark.png';
import './ForgotPassword.css';

const RequestOTP: React.FC = () => {
  const navigate = useNavigate();
  const { theme } = useThemeStore();
  const [email, setEmail] = useState('');

  const handleSubmit = () => {
    console.log('Requesting OTP for email:', email);
    // Navigate to verify OTP page without validation
    navigate('/verify-otp');
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  // Select logo based on theme
  const logo = theme === 'dark' ? logoDark : logoLight;

  return (
    <div className="request-otp-container">
      <div className="request-otp-header">
        <div className="request-otp-logo">
          <img src={logo} alt="Multiplierskraft Logo" className="request-otp-logo-image" />
        </div>
      </div>

      <div className="request-otp-card">

        <h1 className="request-otp-title">Forgot Password?</h1>
        <p className="request-otp-subtitle">
          Enter your registered email address to receive an OTP
        </p>

        <div className="request-otp-form">
          <div className="request-otp-form-group">
            <label className="request-otp-label" htmlFor="email">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              className="request-otp-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder=""
            />
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="request-otp-submit-button"
          >
            Send OTP
          </button>
        </div>

        <div className="request-otp-footer">
          Remember your password?{' '}
          <button
            type="button"
            onClick={handleBackToLogin}
            className="request-otp-login-link"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestOTP;
